(function () {
  function swiperInit() {
    sliderInit(true);
  }

  function updateProductGalleries() {
    document.querySelectorAll(".product-section .js-media-list").forEach((el) => {
      if (el.swiper && !el.swiper.destroyed) {
        el.swiper.update();
      }
    });
    document.querySelectorAll(".product-section .js-media-sublist").forEach((el) => {
      if (el.swiper && !el.swiper.destroyed) {
        el.swiper.update();
      }
    });
  }

  document.addEventListener("shopify:section:load", function () {
    swiperInit();
  });

  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateProductGalleries, 250);
  });

  swiperInit();
})();
